import {Injectable} from '@angular/core';
import {DetailScreenInfoModel} from './detail-screen.model';

@Injectable({
  providedIn: 'root',
})
export class DetailInfoService {

  public detailScreenInfo: DetailScreenInfoModel = {
    arrangementNumber: '',
    arrangementNumbers: [],
    administrationCode: '',
    bankCode: '',
    relationRestrictedDataView: false,
    restrictedDataViewException: false,
    relationMarketSegmentCode: '',
  };

  private processors = {
    onlineKeys: 'setOnlineKeysInfo',
  };

  public setOnlineKeysInfo(data) {
    data.children.forEach((item) => {
      this.detailScreenInfo.arrangementNumbers.push(item.data.arrangementNumber);
    });
  }

  public processData(data, type: string) {
    if (!data) {
      return;
    }
    this[this.processors[type]](data);
  }

}
